import { render } from "./WhereWeBuy.vue?vue&type=template&id=08419a48&scoped=true"
import script from "./WhereWeBuy.vue?vue&type=script&lang=js"
export * from "./WhereWeBuy.vue?vue&type=script&lang=js"

import "./WhereWeBuy.vue?vue&type=style&index=0&id=08419a48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08419a48"]])

export default __exports__